import React from 'react'


const ScormDetailPage = ({scorm_url}) => {
  return (
    <iframe src={scorm_url} title={scorm_url} width="100%" height="650px" scrolling='no' />
  )
}

export default ScormDetailPage